// @ts-check

/**
 * @param {any } value
 * @param {any} filterValue
 * @returns {boolean}
 */
export function tableFilterValueIncludes(value, filterValue) {
  if (!Array.isArray(filterValue) || filterValue.length === 0) {
    return true
  }

  const options = Array.isArray(value) ? value : [value]

  return options.some((option) => filterValue.includes(option))
}
